// extracted by mini-css-extract-plugin
export default {"vrr-modal-footer":"VrrModalFooter_vrr-modal-footer__8h6SR"};